import {Mapper} from '@s-ui/domain'

export default class FromModelsRawDataToModelsListValueObjectMapper extends Mapper {
  constructor({modelEntityFactory, valueObject}) {
    super()
    this._modelEntityFactory = modelEntityFactory
    this._valueObject = valueObject
  }

  map = ({items}) => {
    const itemsList = items.map(({id, label}) => this._modelEntityFactory({id, name: label}))
    return this._valueObject({items: itemsList})
  }
}
